module.exports = __webpack_public_path__ + "static/media/btn6.cba954f1.svg";